<!--  no need for this for now 
-->
<template>
  <div id="contract-addon" class="clearfix noto-sans darkblue px2 mb4">
    <div class="col-12">
          <div class="clearfix ">
            <div class="col-12 mt2 px0 flex justify-between items-center">
                <p class="h1 regular line-height-2 my3 ">ARBEJDSSEDLER</p>
            </div>
            <div id="create-contract" class="clearfix ">
              <div class="height-100vh" v-if="loading">
                <div class="loader"></div>
              </div>
              <div class="contract-wizard" v-else>
                <div class="py1"></div>
                <div class="flex items-center px2 mb4" v-if="activeWizard == 1">
                  <div class="mr1">
                    <p class="h6 mb0">Select:</p>
                  </div>
                  <!-- Select template -->
                  <!--  eslint-disable -->
                  <el-select v-model="selectedContractTemplateId" placeholder="" filterable :no-match-text="'no_data'" :no-data-text="'no_data'" @change="contractTemplateChanged()">
                    <el-option
                      v-for="(template, index) in contractWizardsData"
                      :key="index"
                      :label="template.NAME"
                      :value="template.TEMPLATE_ID">
                    </el-option>
                  </el-select>
                  <!--  eslint-enable -->
                </div>
                <form-wizard id="contractWizard" ref="contractWizard" :start-index="startIndex" shape="tab" color="#ffffff" @on-change="wizardChanged">
                  <tab-content :title="contractWizardStepsData.length > 5 ? wizard.label.length >= 10 ? wizard.label.substring(0, 10) + '...' : wizard.label : wizard.label.length >= 30 ? wizard.label.substring(0, 30) + '...' : wizard.label" :class="'contractTab-' + (index + 1)"  v-for="(wizard, index) in contractWizardStepsData" :key="index" :before-change="validateDynamicTabs">
                    <p class="h2 semi-bold line-height-2 mb3">{{index + 1}}. {{wizard.Info}}</p>
                    <div class="mb3" v-for="(wizField, index1) in wizard.fields" :key="index1">
                      <!-- label -->
                      <p class="m0">
                        <label v-html="wizField.label"></label>
                        <span class="red" v-if="wizField.mandatory == 1">*</span>
                        <el-tooltip placement="top" effect="light" v-if="wizField.help">
                          <div slot="content">
                            <p class="m0" v-html="wizField.help"></p>
                          </div>
                          <i class="shakespeare el-icon-info ml1"></i>
                        </el-tooltip>
                      </p>
                      <!-- Input text -->
                      <el-input class="p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" :placeholder="wizField.place_holder " v-model="wizField.default_value" v-if="wizField.field == 2 && wizField.number == 0"></el-input>
                      <!-- Input number -->
                      <el-input-number class="p0 fields-id-value" @change="getdatafrominput"  :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" :placeholder="wizField.place_holder " v-model="wizField.default_value" :controls="false" :min="0" v-else-if="wizField.field == 2 && wizField.number == 1"></el-input-number>
                      <!-- Radio -->
                      <el-radio-group class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-model="wizField.default_value" fill="#19A3C0" v-else-if="wizField.field == 3">
                        <el-radio :label="option" v-for="(option, optionIndex) in wizField.values" :key="optionIndex">{{option}}</el-radio>
                      </el-radio-group>
                      <!-- Checkbox -->
                      <el-checkbox-group class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-model="wizField.default_value" fill="#19A3C0" v-else-if="wizField.field == 4">
                        <el-checkbox :label="option" v-for="(option, optionIndex) in wizField.values" :key="optionIndex"></el-checkbox>
                      </el-checkbox-group>
                      <!-- Slider -->
                      <el-slider :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" class="fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" v-model="wizField.default_value" :max="parseInt(10)" :step="1" v-else-if="wizField.field == 5">
                      </el-slider>
                      <!-- Select -->
                      <div class="col-12 p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-else-if="wizField.field == 7">
                        <el-select :placeholder="wizField.place_holder " v-model="wizField.default_value" class="col-12 p0">
                          <el-option
                            v-for="(option, optionIndex) in wizField.values"
                            :key="optionIndex"
                            :label="option"
                            :value="option">
                          </el-option>
                        </el-select>
                      </div>
                      <!-- Input textarea -->
                      <div class="p0 fields-id-value" :class="wizField.mandatory == 1 ? 'required' : null" :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value" v-else-if="wizField.field == 8">
                        <el-input
                          type="textarea"
                          :rows="3" 
                          @change="getdatafrominput"
                          :placeholder="wizField.place_holder"
                          v-model="wizField.default_value">
                        </el-input>
                      </div>
                      <!-- Rating -->
                      <el-rate
                        :id="'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value"
                        class="fields-id-value"
                        :class="wizField.mandatory == 1 ? 'required' : null"
                        :high-threshold="10"
                        :low-threshold="1"
                        v-model="wizField.default_value"
                        :max="10"
                        :icon-classes="iconClasses"
                        void-icon-class="el-icon-remove-outline"
                        :colors="colorClasses"
                        v-else-if="wizField.field == 9">
                      </el-rate>
                      <!-- <b-form-datepicker :placeholder="wizField.place_holder" :date-format-options="{ 'year': 'numeric', 'month': 'numeric', 'day': 'numeric' }" v-model="wizField.default_value" v-else-if="wizField.field == 10"></b-form-datepicker> -->
                      <el-date-picker
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        :placeholder="wizField.place_holder"
                        class="col-12 p0"
                        v-model="wizField.default_value"
                        @change="getdatafrominput"
                        v-else-if="wizField.field == 10">
                      </el-date-picker>
                      <!-- Validate fields -->
                      <div v-if="dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == '' || dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == null || dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == undefined" class="small red mt1">
                        required
                      </div>
                    </div>
                  </tab-content>

                  <!-- Wizard footer -->
                  <template slot="footer" slot-scope="props">
                    <div class="py3"></div>
                    <div class="flex justify-between">
                      <!-- <button @click="props.prevTab()" class="outlined-primary-button h5 semi-bold m0 line-height-4 regular button-padding px3" v-if="props.activeTabIndex > 0">
                        <span class="inline-block">back</span>
                      </button> -->
                      <button id="maincontractTab" @click="submitContractInfo()" class="action-button h5 semi-bold m0 line-height-4 regular button-padding px3 ml-auto">
                        <span class="inline-block">{{!props.isLastStep ? 'next' : 'submit'}}</span>
                      </button>
                    </div>
                  </template>
                </form-wizard>
              </div>
            </div>
          </div>
      </div>
      <div class="py4 xs-hide"></div>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import VuePdfApp from 'vue-pdf-app'
import Simplert from 'vue2-simplert'
export default {
  name: 'contract-addon',
  components: {
    VuePdfApp,
    Simplert
  },
  data () {
    return {
      projectID: '',
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 3130899,
      haaId: '',
      salesPersonbitrix: '',
      loading: false,
      showMobile: false,
      info: [],
      activeWizard: null,
      contractWizardsData: [],
      selectedContractTemplateInfo: {},
      contractWizardStepsData: [],
      selectedContractTemplateId: '',
      startIndex: 0,
      dynamicTabSubmitted: false,
      currentProjectData: {},
      selectedmainTemplateId: null,
      paymentstage: [],
      parentID: '',
      contractType: '',
      industryID: [],
      submittedIndustries: [],
      offerType: '',
      childprojects: [],
      total: 0
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.projectID = this.$route.query.projectId
    this.homeownerID = this.$route.query.contactID
    this.haaId = localStorage.getItem('haaid')
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
    if (localStorage.getItem('address') === null || localStorage.getItem('city') === null) {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger')
      this.$router.push('/login')
    } else {
      this.getProjectDetails()
      this.getContractTemplate()
    }
  },
  mounted () {
    this.parentID = this.$route.query.parentID
    this.contractType = this.$route.query.contracttype
    this.industryID = this.$route.query.industryID
    this.childprojects = JSON.parse(this.$route.query.childprojects)
    this.submittedIndustries = JSON.parse(this.$route.query.submittedindustry)
    this.offerType = this.$route.query.offertype
  },
  methods: {
    getProjectDetails () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.currentProjectData = res.data
            this.contractID = res.data.CONTRACT_ID
            this.contractStatus = res.data.CONTRACT_STATUS
            this.homeownerID = res.data.HOMEOWNER.ID
            this.createPaymentsage()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
            this.loading = false
          }
        },
        response => {
          this.loading = false
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getContractTemplate () {
      this.loading = true
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract_templates?contractValue=100000', { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          if (res.success) {
            this.contractWizardsData.push(res.data.result[2])
            this.getContractInfo()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getContractInfo () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers }, data, { emulateJSON: true }).then(
        response => {
          var res = response.body
          this.contractInfo = res.data
          var latestDocumentInfo = this.contractInfo.DOCUMENTS[this.contractInfo.DOCUMENTS.length - 1]
          this.selectedContractTemplateInfo = this.contractWizardsData
          this.selectedContractTemplateId = this.contractWizardsData[0].TEMPLATE_ID
          this.selectedmainTemplateId = this.contractWizardsData[0].ID
          this.selectedContractTemplateInfo.STEPS = latestDocumentInfo.JSON_STEPS
          this.getContractWizardSteps()
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    getdatafrominput () {
      this.contractWizardStepsData.forEach(item => {
        item.fields.forEach(l => {
          if (l.default_value) {
            if (l.label === 'Dato for ændringen') {
              this.paymentstage[0].start_date = l.default_value
            }
            if (l.label === 'Hvad forandres i den forrige kontrakt') {
              this.paymentstage[0].description_payment[0] = l.default_value
            }
            if (l.label === 'Ny deadline') {
              this.paymentstage[0].end_date = l.default_value
            }
            if (l.label === 'Hvordan forandres prisen?') {
              this.paymentstage[0].price_total = l.default_value
            }
          }
        })
      })
    },
    createPaymentsage () {
      var paymentstage = {
        'project_id': this.projectID,
        'partner_id': this.haaId,
        'contact_id': this.homeownerID,
        'calculation_id': 0,
        'industry_id': 0,
        'job_industry_id': 0,
        'price_total': 0,
        'sub_project_id': 0,
        'totalpricewithvatandfee': 0,
        'vat_total': 0,
        'note': '',
        'signature': '',
        'weeks': 0,
        'end_date': '',
        'start_date': '',
        'offer_id': 0,
        'transaction_fee': 0,
        'description_payment': [],
        'contract_type': 'extra_work'
      }
      this.paymentstage.push(paymentstage)
    },
    getInsuranceamount (amount) {
      return new Promise((resolve, reject) => {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        }
        var data = {}
        this.$http.get(this.$bitrixapi + 'integration/InsuranceSettings?totalpriceinclVAT=' + amount, { headers }, data, { emulateJSON: true }).then(
          response => {
            var res = response.body.data
            resolve(res.FEEINAMOUNT)
          },
          response => {
            this.$message({
              type: 'error',
              message: response.body.message
            })
          })
      })
    },
    async submitContractInfo () {
      if (this.paymentstage.price_total === 0 || this.paymentstage[0].end_date === '' || this.paymentstage[0].start_date === '' || this.paymentstage[0].description_payment.length < 1) {
        this.$message({
          type: 'error',
          message: 'Alle felter er obligatoriske'
        })
        return false
      }
      for (var stage in this.paymentstage) {
        this.paymentstage[stage].vat_total = parseFloat(this.paymentstage[stage].price_total * 1.25)
        var vatamountfee = await this.getInsuranceamount(this.paymentstage[stage].vat_total)
        if (vatamountfee > 0) {
          this.paymentstage[stage].transaction_fee = vatamountfee
          this.paymentstage[stage].totalpricewithvatandfee = this.paymentstage[stage].vat_total + vatamountfee
        } else {
          this.paymentstage[stage].totalpricewithvatandfee = this.paymentstage[stage].vat_total
        }
        this.total += Number(this.paymentstage[stage].totalpricewithvatandfee)
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {
        projectId: this.currentProjectData.ID,
        contractLabel: 'extra',
        contactId: this.homeownerID,
        paymentStages: this.paymentstage,
        price: this.total,
        source: 'web',
        contractId: this.contractID
      }
      this.$http.post(this.$bitrixapi + 'partner/extra_work', data, { headers }, { emulateJSON: true }).then(
        response => {
          // var res = response.body
          let obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          }
          this.$refs.simplert.openSimplert(obj)
          setTimeout(() => {
            this.$router.push('/customer-projects/project-dashboard?projectId=' + this.currentProjectData.ID + '&contactID=' + this.homeownerID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + JSON.stringify(this.childprojects) + '&submittedindustry=' + JSON.stringify(this.submittedIndustries) + '&contracttype=' + this.contractType + '&projecttitle=' + this.projectTitle)
          }, 2000)
        },
        response => {
          this.$message({
            type: 'error',
            message: response.body.message
          })
        })
    },
    contractTemplateChanged () {
      this.loading = true
      this.selectedContractTemplateInfo = this.contractWizardsData.filter((wizardProp) => { return wizardProp.TEMPLATE_ID === this.selectedContractTemplateId })[0]
      this.$refs.contractWizard.changeTab(0, 0)
      this.getContractTemplate()
    },
    wizardChanged (prevIndex, nextIndex) {
      this.activeWizard = nextIndex + 1
    },
    getContractWizardSteps () {
      this.contractWizardStepsData = []
      var step = {}
      step['fields'] = {}
      var templateSteps = this.selectedContractTemplateInfo[0].STEPS
      for (var steps in templateSteps) {
        step = templateSteps[steps]
        var fieldsData = []
        for (var fields in step.fields) {
          var stepField = step.fields[fields]
          fieldsData.push(stepField)
        }
        step['fields'] = fieldsData
        this.contractWizardStepsData.push(step)
      }
      this.activeWizard = 1
      this.loading = false
    },
    validateDynamicTabs () {
      var fieldserror = false
      this.contractWizardStepsData.forEach(item => {
        item.fields.forEach(l => {
          if (l.default_value) {
            if (l.default_value) {
              fieldserror = true
            }
          }
        })
      })
      if (fieldserror) {
        this.$message({
          type: 'error',
          message: 'Alle felter er obligatoriske'
        })
        return false
      }
      return true
    }
  }
}
</script>
<style >
  
  #contract-addon marker {
    background-color: aqua;
  }
  #contract-addon .el-input__inner {
    -webkit-appearance: auto;
  }
  #contract-addon .pointer {
    cursor: url(/cursor_1.png) 4 12, auto;
  }
  #contract-addon .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .font12 {
    font-size: 12px;
  }
  .font14 {
    font-size: 14px;
  }
  #contract-addon .wizard-header {
    display: none;
  }
  #contract-addon .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  #contract-addon .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  #contract-addon .el-textarea.is-disabled .el-textarea__inner {
      background-color: #ffffff;
      border-color: #dfe2e9;
      color: #7d8085;
      cursor: not-allowed;
  }
  #contract-addon .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  #contract-addon .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  .commentdiv {
      height: 900px;
      overflow: auto;
    }
  @media (max-width:27em) {
    .mm0 {
    margin: 0px;
    }
    .mmx-auto {
      margin-left: auto;
      -webkit-box-pack: center;
      justify-content: center;
    }
    .mmb5 {
      margin-bottom: 5rem;
    }
    .mpt1 {
      padding-top: .5rem;
    }
    .mobile-flex-column {
      flex-direction: column!important;
      align-items: center;
    }
    .xs-col-12 {
      width: 100%;
    }
    .mobile-100 {
      width: 100%!important;
    }
    .mp2 {
      padding: 1em;
    }
    .commentdiv {
      height: 750px;
      overflow:auto;
    }
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes pulse {
      0% {
        height: 1em;
        width:1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
        opacity: 0.2;
      }
      50% {
        opacity: 0.9;
        height: 3em;
        width: 3em;
        margin-top: -1.5em;
        margin-left: -1.5em;
      }
      100% {
        opacity: 0.2;
        height: 1em;
        width: 1em;
        margin-top: -0.5em;
        margin-left: -0.5em;
      }
  }
</style>


// WEBPACK FOOTER //
// contract_extrawork_addon.vue?7f9d38e0